import { Phone, Mail, Instagram, Globe } from "lucide-react";

const NAV = [
  { href: "#servicos", label: "Serviços" },
  { href: "#economia", label: "Economia" },
  { href: "#manifesto", label: "Manifesto" },
  { href: "#atuacao", label: "Atuação" },
  { href: "#sustentabilidade", label: "Sustentabilidade" },
  { href: "#contato", label: "Contato" },
];

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#10204E] py-14" data-testid="main-footer">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid grid-cols-1 gap-10 md:grid-cols-3">
        <div>
          <div className="flex items-center gap-3">
            <span className="flex h-14 items-center justify-center rounded-xl bg-white px-3 py-2 shadow-md">
              <img src="/assets/logo-nova.png" alt="ResgateCar" className="h-full w-auto object-contain" />
            </span>
          </div>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
            Monitoramento, rastreamento e resgate de carrinhos de supermercado com atuação nacional — conformidade
            legal, sustentabilidade e economia real.
          </p>
        </div>

        <div>
          <p className="font-tech text-[11px] font-bold uppercase tracking-[0.25em] text-slate-300">Navegação</p>
          <ul className="mt-4 space-y-2.5">
            {NAV.map((n) => (
              <li key={n.href}>
                <a
                  href={n.href}
                  data-testid={`footer-link-${n.label.toLowerCase()}`}
                  className="text-sm text-slate-400 transition-colors hover:text-[#A3E635]"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="font-tech text-[11px] font-bold uppercase tracking-[0.25em] text-slate-300">Fale conosco</p>
          <ul className="mt-4 space-y-3 text-sm text-slate-400">
            <li className="flex items-center gap-3">
              <Phone className="h-4 w-4 text-[#A3E635]" /> (31) 99228-4075
            </li>
            <li className="flex items-center gap-3 break-all">
              <Mail className="h-4 w-4 shrink-0 text-[#A3E635]" /> resgatecaroficial@gmail.com
            </li>
            <li className="flex items-center gap-3">
              <Instagram className="h-4 w-4 text-[#A3E635]" /> @resgatecaroficial
            </li>
            <li className="flex items-center gap-3">
              <Globe className="h-4 w-4 text-[#A3E635]" /> www.resgatecia.com.br
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 sm:flex-row">
        <p className="font-tech text-[11px] uppercase tracking-[0.18em] text-slate-500">
          © {new Date().getFullYear()} ResgateCar · Todos os direitos reservados
        </p>
        <p className="font-tech text-[11px] uppercase tracking-[0.18em] text-slate-500">
          Carrinho monitorado · Economia real
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
